import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useState } from 'react';
import clsx from 'clsx';
import { useAuth } from '../../shared/context/AuthContext';

export default function PageContainer({ title, showBreadcrumb = false }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarCollapsed((prev) => !prev);
  const toggleMobileSidebar = () => setSidebarOpen((prev) => !prev);

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-[var(--bg-primary)]">
      <Sidebar
        currentPath="/"
        onNavigate={handleNavigate}
        collapsed={sidebarCollapsed}
        onToggleCollapse={toggleSidebar}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        user={user}
        onLogout={logout}
      />

      <Header
        title={title}
        onMenuToggle={toggleMobileSidebar}
        user={user}
        onLogout={logout}
        showBreadcrumb={showBreadcrumb}
        currentPath="/"
      />

      <main
        className={clsx(
          'pt-[var(--header-height)] transition-all duration-300',
          sidebarCollapsed
            ? 'lg:pl-[var(--sidebar-collapsed)]'
            : 'lg:pl-[var(--sidebar-width)]'
        )}
      >
        <div className="p-4 lg:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
